'use client';
import Carousel from '@ui/Carousel';

interface ResponsiveCarouselProps {
  items: React.ReactNode[];
  desktopIncrementBy?: number;
  mobileIncrementBy?: number;
  basis?: string;
  className?: string;
}

export const ResponsiveCarousel = ({
  items,
  desktopIncrementBy = 3,
  mobileIncrementBy = 2,
  basis = 'basis-[48%] sm:basis-auto',
  className,
}: ResponsiveCarouselProps) => {
  return (
    <>
      <div className="hidden sm:block">
        <Carousel
          incrementBy={desktopIncrementBy}
          basis={basis}
          className={className}
          items={items}
        />
      </div>
      <div className="block sm:hidden">
        <Carousel
          incrementBy={mobileIncrementBy}
          basis={basis}
          className={className}
          items={items}
        />
      </div>
    </>
  );
};
